/**
 * Conversions for Google Analytics, and through it Google Ads (Ad Grants).
 *
 * Pushes GA4's recommended event names into the Tag Manager dataLayer. The
 * GTM container (GTM-NDPCMNG) sends each one to GA4 as an event, GA4 marks
 * them as key events, and Google Ads imports those as conversions. The steps
 * outside the code: docs/analytics/ga4-conversions.md.
 *
 * Never carries anything a person typed or who they are (no email, name,
 * phone, message text): only what kind of action it was. Never throws.
 */

export const CONVERSIONS = {
  signUp: 'sign_up',          // an account was created: { method: 'email' | 'google' | 'facebook' }
  lead: 'generate_lead',      // a lead form arrived: { lead_type }
  chatStart: 'chat_start',    // the first message of a conversation with the assistant
};

export const trackConversion = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch { /* no analytics, the site still works */ }
};
